const Routes = {
  home: "/",
  chatbot: "/chatbot",
};

export default Routes;
